/*
 * @Author: your name
 * @Date: 2021-09-20 10:54:02
 * @LastEditTime: 2021-09-22 08:38:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\i18n\index.js
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'

import cn from './lang/cn'
import en from './lang/en'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: sessionStorage.lang || 'en',
  messages: {
    cn,
    en
  }
})

locale.i18n((key, value) => i18n.t(key, value))

export default i18n
